import React from 'react';

import Filterable from '@components/Filterable/Filterable';
import IllustrationsList from './IllustrationsList/IllustrationsList';
import { illustrationsSet } from './Illustrationset';
import { FILTERS } from './constants';

/*
  Presentational component for Illustrations
*/

const Illustrations = () => (
  <Filterable
    customClasses={'main-content'}
    filters={FILTERS}
    data={illustrationsSet}
    placeholder={'illustration'}
  >
    <IllustrationsList />
  </Filterable>
);

Illustrations.displayName = 'Illustrations';

export default Illustrations;



// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/Illustrations.js